import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import LoginModal from "./components/auth/LoginModal";
import RegisterModal from "./components/auth/RegisterModal";
import ScrollToTop from "./components/common/ScrollToTop";
import Home from "./components/Home";
import Filter from "./components/Filter";
import Viewproduct from "./components/Viewproduct";
import Cart from "./components/Cart";
import Payment from "./components/Payment";
import Order from "./components/Order";
import Profile from "./components/Profile";
import Wishlist from "./components/Wishlist";
import Offers from "./components/Offers";
import "./App.css";

// Admin
import Login from "./Admin/Login";
import Header from "./Admin/Header";
import Products from "./Admin/Products";
import AddProduct from "./Admin/AddProduct";
import Category from "./Admin/Category";
import Orders from "./Admin/Orders";
import Subcategory from "./Admin/Subcategory";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <LoginModal />
          <RegisterModal />
          <Routes>
            {/* Customer Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/filter" element={<Filter />} />
            <Route path="/filter/:id" element={<Filter />} />
            <Route path="/viewproduct/:id" element={<Viewproduct />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/orders" element={<Order />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/offers" element={<Offers />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<Login />} />
            <Route path="/admin/Header" element={<Header />} />
            <Route path="/admin/Products" element={<Products />} />
            <Route path="/admin/AddProduct" element={<AddProduct />} />
            <Route path="/admin/AddProduct/:id" element={<AddProduct />} />
            <Route path="/admin/Orders" element={<Orders />} />
            <Route path="/admin/Category" element={<Category />} />
            <Route path="/admin/SubCategory" element={<Subcategory />} />
          </Routes>
          <ScrollToTop />
          <ToastContainer position="bottom-right" autoClose={3000} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
